import { apiFetch } from "./client";

export const authApi = {
  login: (payload) =>
    apiFetch("/auth/login", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  signup: (payload) =>
    apiFetch("/auth/signup", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  logout: () =>
    apiFetch("/auth/logout", {
      method: "POST",
    }),

  me: () => apiFetch("/auth/me"),
};
